
import React from 'react';
import CareerGuidance from '../../CareerGuidance';

const GuidanceTab: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-6">
      <CareerGuidance />
    </div>
  );
};

export default GuidanceTab;
